import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarDriversApi } from "../../http/carDrivers/api";
import { CarCurrentAssignment } from "../../http/cars/types";
import SvgAdd from "../icons/Add";
import Button from "../ui/Button";
import ModalDialog from "../ui/ModalDialog";
import CarDriverForm, { CarDriverFormBody } from "./CarDriverForm";

interface CreateCarDriverButtonProps {
  onUpdate?: () => void;
  carId?: string;
}

const CreateCarDriverButton: FC<CreateCarDriverButtonProps> = ({ onUpdate, carId }) => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const carDriversApi = useCarDriversApi();

  const onSubmit = async (formData: CarDriverFormBody, ass?: CarCurrentAssignment) => {
    setIsSubmitting(true);
    try {
      if (ass && formData.prevEndDate) {
        await carDriversApi.assignNewDriver({
          carId: carId ?? formData.car.id,
          driverId: formData.driver.id,
          startDate: formData.startDate,
          endDate: formData.endDate,
          typeOfUse: formData.typeOfUse.value,
          sendMileageEmail: formData.sendMileageEmail,
          prevEndDate: formData.prevEndDate,
          currentVersionNumber: ass.carDriver?.versionNumber ?? ass.otherCarAssignment?.versionNumber,
        });
      } else {
        await carDriversApi.insertAdminCarDriver({
          carId: carId ?? formData.car.id,
          driverId: formData.driver.id,
          startDate: formData.startDate,
          endDate: formData.endDate,
          typeOfUse: formData.typeOfUse.value,
          sendMileageEmail: formData.sendMileageEmail,
        });
      }
      dispatch(showSuccessNotification(i18n.t));
      onUpdate && onUpdate();
      setShow(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.carDrivers.new}>
          <CarDriverForm isDisabled={isSubmitting} onSubmit={onSubmit} carId={carId} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateCarDriverButton;
